import React from 'react';
import handsImage from '../assets/hands.png';
import MonalisaImage from './MonalisaImage';

export default function SearchBar({ keyword, setKeyword, search }) {
    function handleKeywordChange(event) {
        setKeyword(event.target.value);
    }

    return (
        <div className="search-bar-container">
            <MonalisaImage />
            <h2 className="description">What word do you want to look up today?</h2>
            <form onSubmit={search} className="search-form">
                <input type="search" value={keyword} onChange={handleKeywordChange} />
                <button type="submit" className="search-button">
                    <img src={handsImage} alt="Search" className="hands-icon" />
                </button>
            </form>
            <div className="hint">
                suggested words: sunset, wine, yoga, plant...
            </div>
        </div>
    );
}
